<template>
  <div
    class="fixed flex flex-col justify-center items-center inset-0 bg-white text-4xl backdrop-blur-sm bg-white/50 z-30"
  >
    <font-awesome-icon
      v-if="value"
      icon="fas fa-spinner"
      spin
    ></font-awesome-icon>
    <LogoView v-else class="animate-pulse text-yellow-700" />
    <span v-if="value"> {{ value }} % </span>
  </div>
</template>
<script>
import LogoView from "./Logo.vue";
export default {
  name: "loadingView",
  components: {
    LogoView,
  },
  props: {
    value: String,
  },
};
</script>
